module.exports = __webpack_public_path__ + "img/adopt.db966d6b.png";